import { useDrag } from 'react-dnd';

import { ItemType } from 'partsOld/enums';
import { IPill } from 'partsOld/types';

import PillView from './PillView';

interface IProps {
  pill: IPill;
  showCloseIcon?: boolean;
}

const Pill = ({ pill, showCloseIcon = false }: IProps) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemType.PILL,
    item: { ...pill },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return <PillView drag={drag} isDragging={isDragging} showCloseIcon={showCloseIcon} pill={pill} />;
};
export default Pill;
